export default __webpack_public_path__ + "static/media/pattern.91db404e.png";